(function () {
const COLOR_VARIANTS_TAG = 'color-variants';

if (customElements.get(COLOR_VARIANTS_TAG) || window.__colorVariantsRegistered) {
    return;
}

window.__colorVariantsRegistered = true;

class ColorVariants extends HTMLElement {
    constructor() {
        super();
        window.colorVariantSwitching = false;
        this.init();
    }

    init() {
        this.colorVariants = this.querySelectorAll('.color-variant-single');
        this.mediaGallery = document.querySelector('media-gallery');
        this.colorNameElement = this.querySelector('.color-name');
        this.setupEventListeners();
        this.setupSwatchAccessibility();
        this.syncColorNameWithActiveVariant();
    }

    setupSwatchAccessibility() {
        this.colorVariants.forEach((variant) => {
            if (variant.closest('.colors-attached-with-style')) {
                variant.setAttribute('tabindex', '-1');
                return;
            }

            variant.setAttribute('tabindex', '0');
            variant.setAttribute(
                'aria-current',
                variant.classList.contains('active') ? 'true' : 'false'
            );
        });
    }

    setupEventListeners() {
        this.colorVariants.forEach((variant) => {
            variant.addEventListener('click', (e) => {
                this.handleVariantClick(e.currentTarget);
            });

            variant.addEventListener('keydown', (e) => {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                if (variant.classList.contains('active')) return;
                e.preventDefault();
                this.handleVariantClick(variant);
            });
        });
    }

    handleVariantClick(clickedVariant) {
        try {
            this.colorVariants.forEach((variant) => {
                variant.classList.remove('active');
            });

            clickedVariant.classList.add('active');
            this.updateColorName(clickedVariant);
            this.setupSwatchAccessibility();

            const productDataString = clickedVariant.dataset.productJson;
            if (!productDataString) return;

            const productData = JSON.parse(productDataString);

            window.colorVariantSwitching = true;

            if (typeof window.WarRoadScheduleStickyAtcTiloSync === 'function') {
                window.WarRoadScheduleStickyAtcTiloSync(productData);
            }

            this.updateMediaGallery(productData);
            this.updateBasicProductInfo(productData);
            this.updateSavingsBadge(productData);
            this.updateReviewsInfo(productData);
            this.hideVariantSelectorTemporarily();
            this.updateVariantSelector(productData);
            this.startExternalVariantVisibilityGuard(productData);
            this.updateNotifyMePopup(productData);
            this.updateTiloFreeSockPromo(productData, clickedVariant);
            this.updateTiloFreeSockBadge(productData);
            this.updateTickerCallout(productData);

            const firstVariant = this.getFirstVisibleVariant(productData);
            if (firstVariant) {
                this.updateAddToCartButton(firstVariant);
            }
            
            setTimeout(() => {
                this.updatePageInfo(productData);
                
                setTimeout(() => {
                    this.updatePageInfo(productData);
                    
                    setTimeout(() => {
                        const variantSelector = this.getActiveVariantSelector();
                        if (variantSelector) {
                            this.clickFirstVariant(variantSelector);
                        }
                        window.Shop?.productInfoEl?.setupTiloPromotionMultiSize?.();
                        window.colorVariantSwitching = false;
                    }, 100);
                }, 200);
            }, 300);

        } catch (error) {
            console.error('Error handling color variant click:', error);
            window.colorVariantSwitching = false;
        }
    }

    syncColorNameWithActiveVariant() {
        const activeVariant = this.querySelector('.color-variant-single.active') || this.colorVariants[0];
        this.updateColorName(activeVariant);
    }

    updateColorName(variantElement) {
        if (!this.colorNameElement) return;
        const colorName = variantElement?.dataset?.colorName || '';
        this.colorNameElement.textContent = colorName;
    }

    updateMediaGallery(productData) {
        if (!this.mediaGallery || !productData.media) return;

        const swiperWrapper = this.mediaGallery.querySelector('.swiper-wrapper');
        const thumbnailsContainer = this.mediaGallery.querySelector('.product-thumbnails');

        if (!swiperWrapper) return;

        if (window.Shop?.productInfoEl?.swiper) {
            window.Shop.productInfoEl.swiper.destroy(true, true);
            window.Shop.productInfoEl.swiper = null;
        }

        swiperWrapper.innerHTML = '';
        if (thumbnailsContainer) {
            thumbnailsContainer.innerHTML = '';
        }

        productData.media.forEach((media, index) => {
            const slide = this.createSlide(media, index);
            swiperWrapper.appendChild(slide);

            if (thumbnailsContainer) {
                const thumbnail = this.createThumbnail(media, index);
                thumbnailsContainer.appendChild(thumbnail);
            }
        });
        
        this.recreateZoomIcon();
        setTimeout(() => {
            this.updateModalContent(productData);
            window.Shop?.productInfoEl?.initSwiper();
            this.reinitializeMagnify();
            if (typeof window.WarRoadRebindTiloGallerySlideCounter === 'function') {
                window.WarRoadRebindTiloGallerySlideCounter();
            }
            setTimeout(() => {
                if (typeof window.WarRoadRebindTiloGallerySlideCounter === 'function') {
                    window.WarRoadRebindTiloGallerySlideCounter();
                }
            }, 200);
        }, 100);  
    }

    createSlide(media, index) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.setAttribute('data-media-id', media.id);
        slide.setAttribute('data-media-index', index);

        
        const originalZoomTrigger = this.mediaGallery?.querySelector('.light-box-zoom-trigger');
        const originalZoomIcon = this.mediaGallery?.querySelector('.product__media-icon');
        const isZoomEnabled = originalZoomTrigger || originalZoomIcon;
        const isHoverZoom = this.mediaGallery?.querySelector('.hover-zoom-enabled') !== null;

        
        if (isHoverZoom) {
            const loadingSpinner = document.createElement('div');
            loadingSpinner.className = 'loading__spinner hidden';
            loadingSpinner.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>';
            slide.appendChild(loadingSpinner);
        }

        const productMedia = document.createElement('div');
        productMedia.className = 'product-media';

        
        if (isZoomEnabled) {
            const zoomTrigger = document.createElement('div');
            zoomTrigger.className = 'light-box-zoom-trigger';
            if (isHoverZoom) {
                zoomTrigger.classList.add('hover-zoom-enabled');
            }
            zoomTrigger.setAttribute('data-media-id', media.id);
            zoomTrigger.setAttribute('data-modal', '#ProductModal-' + (this.getSectionId() || ''));
            zoomTrigger.innerHTML = '&nbsp;';
            productMedia.appendChild(zoomTrigger);
        }

        this.createMediaElement(media, productMedia);
        slide.appendChild(productMedia);
        return slide;
    }

    createMediaElement(media, container) {
        if (media.media_type === 'image') {
            const img = document.createElement('img');
            
            // Clean the URL and add width parameter
            const baseSrc = media.src.split('?')[0];
            const urlParams = new URLSearchParams(media.src.split('?')[1] || '');
            urlParams.set('width', '900');
            img.src = `${baseSrc}?${urlParams.toString()}`;
            
            img.alt = media.alt || '';
            img.loading = 'eager';
            img.className = 'image-magnify-hover';
            img.setAttribute('data-media-id', media.id);
            img.setAttribute('fetchpriority', 'high');
            
            // Add height if available
            if (media.height) {
                img.height = media.height;
            }
            
            // Create srcset for responsive images
            const srcsetSizes = [600, 800];
            const srcset = srcsetSizes.map(width => {
                const params = new URLSearchParams(media.src.split('?')[1] || '');
                params.set('width', width.toString());
                return `${baseSrc}?${params.toString()} ${width}w`;
            }).join(', ');
            
            img.setAttribute('srcset', srcset);
            img.style.width = '100%';
            img.style.height = 'auto';
            
            container.appendChild(img);
        } else if (media.media_type === 'video') {
            const video = document.createElement('video');
            video.src = media.sources?.[0]?.url || media.src;
            video.controls = true;
            video.autoplay = true;
            video.setAttribute('playsinline', true);
            video.loop = true;
            video.preload = 'none';
            video.style.width = '100%';
            video.style.height = 'auto';
            video.setAttribute('data-media-id', media.id);
            container.appendChild(video);
        } else {
            const img = document.createElement('img');
            const previewSrc = media.preview_image?.src || media.src;
            
            // Clean the URL and add width parameter
            const baseSrc = previewSrc.split('?')[0];
            const urlParams = new URLSearchParams(previewSrc.split('?')[1] || '');
            urlParams.set('width', '900');
            img.src = `${baseSrc}?${urlParams.toString()}`;
            
            img.alt = media.alt || '';
            img.loading = 'eager';
            img.setAttribute('fetchpriority', 'high');
            
            // Add height if available
            if (media.preview_image?.height || media.height) {
                img.height = media.preview_image?.height || media.height;
            }
            
            // Create srcset for responsive images
            const srcsetSizes = [600, 800];
            const srcset = srcsetSizes.map(width => {
                const params = new URLSearchParams(previewSrc.split('?')[1] || '');
                params.set('width', width.toString());
                return `${baseSrc}?${params.toString()} ${width}w`;
            }).join(', ');
            
            img.setAttribute('srcset', srcset);
            img.style.width = '100%';
            img.style.height = 'auto';
            
            container.appendChild(img);
        }
    }

    getSectionId() {
        const productInfo = document.querySelector('product-info');
        return productInfo?.getAttribute('data-section') || '';
    }

    createThumbnail(media, index) {
        const thumbnail = document.createElement('div');
        thumbnail.className = 'thumbnail-item';
        thumbnail.setAttribute('data-media-index', index);

        const img = document.createElement('img');
        const imageUrl = media.preview_image?.src || media.src;
        
        // Clean the URL and add width parameter for thumbnail
        const baseSrc = imageUrl.split('?')[0];
        const urlParams = new URLSearchParams(imageUrl.split('?')[1] || '');
        urlParams.set('width', '100');
        img.src = `${baseSrc}?${urlParams.toString()}`;
        
        img.alt = media.alt || '';
        img.width = 100;
        img.height = 100;
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'high');

        thumbnail.appendChild(img);
        return thumbnail;
    }

    updateBasicProductInfo(productData) {
        const titleElement = document.querySelector('.product__title h1');
        if (titleElement) {
            titleElement.textContent = productData.title;
        }

        const descriptionElement = document.querySelector('.product__description p');
        if (descriptionElement) {
            descriptionElement.textContent = productData.description;
        }

        
        const firstVariant = this.getFirstVisibleVariant(productData);
        if (firstVariant) {
            this.updatePrice(firstVariant);
            this.updateSKU(firstVariant);
            this.updateInventory(firstVariant);
            this.updateAddToCartForm(firstVariant);
        }

        setTimeout(() => {
            const selectedVariantRadio = document.querySelector('input.pill-radio:checked');
            if (selectedVariantRadio) {
                selectedVariantRadio.click();
            }
        }, 2000);
    }

    async updateSavingsBadge(productData) {
        const gallerySlider = this.mediaGallery?.querySelector('.gallery-slider');
        if (!gallerySlider || !productData?.url) return;

        this.savingsBadgeRequestId = (this.savingsBadgeRequestId || 0) + 1;
        const currentRequestId = this.savingsBadgeRequestId;

        try {
            const response = await fetch(productData.url, { credentials: 'same-origin' });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseText = await response.text();
            if (currentRequestId !== this.savingsBadgeRequestId) return;

            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, 'text/html');
            const incomingBadge = doc.querySelector('media-gallery .gallery-slider .savings-badge');
            const existingBadge = gallerySlider.querySelector('.savings-badge');

            if (!incomingBadge) {
                if (existingBadge) {
                    existingBadge.remove();
                }
                return;
            }

            const newBadge = incomingBadge.cloneNode(true);
            if (existingBadge) {
                existingBadge.replaceWith(newBadge);
                return;
            }

            const insertionPoint = gallerySlider.querySelector('.oshie-choice, .tilo-free-sock-badge--pdp, .swiper-wrapper');
            if (insertionPoint) {
                gallerySlider.insertBefore(newBadge, insertionPoint);
            } else {
                gallerySlider.prepend(newBadge);
            }
        } catch (error) {
            console.warn('Could not update savings badge:', error);
        }
    }

    async updateTiloFreeSockBadge(productData) {
        const gallerySlider = this.mediaGallery?.querySelector('.gallery-slider');
        if (!gallerySlider || !productData?.url) return;

        this.tiloBadgeRequestId = (this.tiloBadgeRequestId || 0) + 1;
        const currentRequestId = this.tiloBadgeRequestId;

        try {
            const response = await fetch(productData.url, { credentials: 'same-origin' });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseText = await response.text();
            if (currentRequestId !== this.tiloBadgeRequestId) return;

            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, 'text/html');
            const incomingBadge = doc.querySelector('media-gallery .gallery-slider .tilo-free-sock-badge--pdp');
            const existingBadge = gallerySlider.querySelector('.tilo-free-sock-badge--pdp');

            if (!incomingBadge) {
                if (existingBadge) {
                    existingBadge.remove();
                }
                return;
            }

            const newBadge = incomingBadge.cloneNode(true);
            if (existingBadge) {
                existingBadge.replaceWith(newBadge);
                return;
            }

            const insertionPoint = gallerySlider.querySelector('.swiper-wrapper');
            if (insertionPoint) {
                gallerySlider.insertBefore(newBadge, insertionPoint);
            } else {
                gallerySlider.appendChild(newBadge);
            }
        } catch (error) {
            console.warn('Could not update TILO free sock badge:', error);
        }
    }

    updateReviewsInfo(productData) {
  
        const judgeMeTitle = document.querySelector('.judge-me-title');
        if (judgeMeTitle) {
            judgeMeTitle.style.display = '';
            judgeMeTitle.setAttribute('data-product-id', productData.id);
        }

        
        const judgeMeWidgets = document.querySelectorAll('[data-product-id]');
        judgeMeWidgets.forEach(widget => {
            if (widget.hasAttribute('data-product-id')) {
                widget.setAttribute('data-product-id', productData.id);
            }
        });

        
        this.fetchAndUpdateReviewData(productData);

        
        if (typeof window.jdgm !== 'undefined' && window.jdgm.refresh) {
            setTimeout(() => {
                window.jdgm.refresh();
            }, 100);
        }
    }

    async fetchAndUpdateReviewData(productData) {
        try {
            
            const response = await fetch(productData.url);
            const text = await response.text();
            this.parseAndUpdateReviewsFromHTML(text);
        } catch (error) {
            console.warn('Could not fetch review data:', error);
            
        }
    }

    parseAndUpdateReviewsFromHTML(htmlText) {
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            
            
            const judgeMeTitle = doc.querySelector('.judge-me-title');
            if (judgeMeTitle) {
                
                const currentJudgeMeTitle = document.querySelector('.judge-me-title');
                if (currentJudgeMeTitle) {
                    
                    currentJudgeMeTitle.style.display = '';
                    currentJudgeMeTitle.outerHTML = judgeMeTitle.outerHTML;
                }
            }
        } catch (error) {
            console.warn('Error parsing review HTML:', error);
            
            const currentJudgeMeTitle = document.querySelector('.judge-me-title');
            if (currentJudgeMeTitle) {
                currentJudgeMeTitle.style.display = '';
            }
        }
    }

    updatePrice(variant) {
        const priceContainer = document.querySelector('.product__price');
        if (!priceContainer) return;

        const price = this.formatPrice(variant.price);
        const compareAtPrice = variant.compare_at_price ? this.formatPrice(variant.compare_at_price) : null;

        const regularPriceElements = priceContainer.querySelectorAll('.price-item--regular');
        regularPriceElements.forEach(element => {
            if (!element.closest('.price__sale')) {
                element.textContent = price;
            }
        });

        if (compareAtPrice && compareAtPrice !== price) {
            const salePriceElements = priceContainer.querySelectorAll('.price-item--sale');
            salePriceElements.forEach(element => {
                element.textContent = price;
            });

            const compareElements = priceContainer.querySelectorAll('.price__sale .price-item--regular');
            compareElements.forEach(element => {
                element.textContent = compareAtPrice;
            });

            priceContainer.classList.add('price--on-sale');
        } else {
            priceContainer.classList.remove('price--on-sale');
        }
    }

    updateSKU(variant) {
        const skuElement = document.querySelector('.product__sku');
        if (skuElement) {
            if (variant.sku) {
                skuElement.textContent = variant.sku;
                skuElement.classList.remove('visibility-hidden');
            } else {
                skuElement.classList.add('visibility-hidden');
            }
        }
    }

    updateInventory(variant) {
        const inventoryElement = document.querySelector('.product__inventory');
        if (!inventoryElement || variant.inventory_management !== 'shopify') {
            if (inventoryElement) inventoryElement.classList.add('visibility-hidden');
            return;
        }

        inventoryElement.classList.remove('visibility-hidden');
        const svgWrapper = inventoryElement.querySelector('.svg-wrapper');

        const textNodes = Array.from(inventoryElement.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
        textNodes.forEach(node => node.remove());

        if (variant.inventory_quantity > 0) {
            if (variant.inventory_quantity <= 10) {
                if (svgWrapper) svgWrapper.style.color = 'rgb(238, 148, 65)';
                inventoryElement.appendChild(document.createTextNode(` ${variant.inventory_quantity} left in stock`));
            } else {
                if (svgWrapper) svgWrapper.style.color = 'rgb(62, 214, 96)';
                inventoryElement.appendChild(document.createTextNode(' In stock'));
            }
        } else {
            if (svgWrapper) svgWrapper.style.color = 'rgb(200, 200, 200)';
            inventoryElement.appendChild(document.createTextNode(' Out of stock'));
        }
    }

    updateAddToCartForm(variant) {
        if (!variant || typeof variant.id === 'undefined') {
            return;
        }

        setTimeout(() => {
            const productForms = document.querySelectorAll('form[action*="/cart/add"]');
            const notifyMeTrigger = document.querySelector('.notify-me-popup-trigger');

            productForms.forEach(form => {
                const variantInput = form.querySelector('input[name="id"]');
                if (variantInput) {
                    variantInput.value = variant.id;
                }

                const ajaxCartForm = form.closest('ajax-cart-product-form');
                if (ajaxCartForm) {
                    const button = form.querySelector('button.button--primary, button.button--secondary');
                    if (button) {
                        const isAvailable = typeof variant.available !== 'undefined' ? variant.available : true;

                        if (notifyMeTrigger) {
                            notifyMeTrigger.style.display = 'none';
                        }
                        ajaxCartForm.style.display = 'none';

                        if (isAvailable) {
                            ajaxCartForm.style.display = 'block';
                            button.disabled = false;
                            button.textContent = 'Add to cart';
                        } else {
                            if (notifyMeTrigger) {
                                notifyMeTrigger.style.display = 'block';
                            }
                            button.disabled = true;
                            button.textContent = 'Notify Me When Available!';
                        }
                    }
                }
            });
        }, 200);
    }

    /**
     * Matches Liquid: {{ block.settings.option_heading | default: option.name }}
     * Host keeps data-option-heading when innerHTML is cleared.
     */
    resolveVariantOptionLabel(variantSelectorHost, optionName) {
        const normalizedOptionName = String(optionName || '').trim().toLowerCase();
        if (normalizedOptionName === 'size') {
            return 'Select a Size';
        }
        const custom = variantSelectorHost?.dataset?.optionHeading?.trim();
        return custom ? custom : optionName || '';
    }

    getDisplayOptionValue(optionName, rawValue) {
        const normalizedOptionName = String(optionName || '').trim().toLowerCase();
        if (!normalizedOptionName.includes('size')) return rawValue;

        const valueLower = String(rawValue || '').trim().toLowerCase();
        switch (valueLower) {
            case 'extra small':
            case 'xsmall':
            case 'x-small':
                return 'XS';
            case 'small':
                return 'S';
            case 'medium':
                return 'M';
            case 'large':
                return 'L';
            case 'extra large':
                return 'XL';
            default:
                return rawValue;
        }
    }

    updateVariantSelector(productData) {
        const variantSelector = this.getActiveVariantSelector();
        if (!variantSelector || productData.has_only_default_variant) return;

        const sectionId = this.getSectionId();
        const pickerType = variantSelector.getAttribute('data-picker-type');

        variantSelector.innerHTML = '';

        if (pickerType === 'dropdown') {
            this.createDropdownVariantPicker(variantSelector, productData, sectionId);
        } else if (pickerType === 'button') {
            this.createButtonVariantPicker(variantSelector, productData, sectionId);
        }

        this.appendExternalVariantOption(variantSelector, productData, pickerType);

        // Add event listeners to the newly created variant selector
        this.addVariantSelectorEventListeners(variantSelector);
        
        const selectedVariant = this.getFirstVisibleVariant(productData);
        const script = document.createElement('script');
        script.type = 'application/json';
        script.setAttribute('data-selected-variant', '');
        script.textContent = JSON.stringify(selectedVariant);
        variantSelector.appendChild(script);

        // Update button for the initially selected variant
        this.updateButtonForSelectedVariant(variantSelector);
        window.Shop?.productInfoEl?.syncPillVariantTabOrder?.();
    }

    getActiveVariantSelector() {
        if (window.Shop?.productInfoEl) {
            const scopedSelector = window.Shop.productInfoEl.querySelector('variant-selector');
            if (scopedSelector) return scopedSelector;
        }
        return document.querySelector('product-info variant-selector');
    }

    getExternalVariantConfigs(variantSelector) {
        const dataset = variantSelector?.dataset || {};
        const attributeNames = variantSelector?.getAttributeNames?.() || [];
        const indexedConfigKeys = attributeNames
            .map((name) => {
                const match = name.match(/^data-external-variant-(\d+)-id$/);
                return match ? Number(match[1]) : null;
            })
            .filter((index) => Number.isInteger(index) && index > 0)
            .sort((a, b) => a - b);

        const configMap = new Map();

        for (const configIndex of indexedConfigKeys) {
            const externalVariantId = parseInt(
                variantSelector.getAttribute(`data-external-variant-${configIndex}-id`) || '',
                10
            );
            const externalVariantLabel = String(
                variantSelector.getAttribute(`data-external-variant-${configIndex}-label`) || ''
            ).trim();
            const hostHandlesCsv = String(
                variantSelector.getAttribute(`data-external-host-product-handles-${configIndex}`) || ''
            ).trim();

            if (!externalVariantId || !externalVariantLabel) continue;

            configMap.set(String(externalVariantId), {
                externalVariantId,
                externalVariantLabel,
                hostHandlesCsv,
            });
        }

        const legacyVariantId = parseInt(dataset.externalVariantId || '', 10);
        const legacyVariantLabel = String(dataset.externalVariantLabel || '').trim();
        if (legacyVariantId && legacyVariantLabel && !configMap.has(String(legacyVariantId))) {
            configMap.set(String(legacyVariantId), {
                externalVariantId: legacyVariantId,
                externalVariantLabel: legacyVariantLabel,
                hostHandlesCsv: String(dataset.externalHostProductHandles || '').trim(),
            });
        }

        return Array.from(configMap.values());
    }

    getProductHandleForExternalMatching(productData) {
        const directHandle = String(productData?.handle || '').trim().toLowerCase();
        if (directHandle) return directHandle;

        const productUrl = String(productData?.url || '').trim();
        if (!productUrl) return '';

        try {
            const url = new URL(productUrl, window.location.origin);
            const pathSegments = url.pathname.split('/').filter(Boolean);
            const productsIndex = pathSegments.indexOf('products');
            if (productsIndex === -1) return '';
            return String(pathSegments[productsIndex + 1] || '').trim().toLowerCase();
        } catch (error) {
            const match = productUrl.match(/\/products\/([^/?#]+)/i);
            return match?.[1] ? String(match[1]).trim().toLowerCase() : '';
        }
    }

    isExternalVariantAllowedForProduct(config, productData) {
        const hostHandlesCsv = String(config?.hostHandlesCsv || '').trim();
        const productHandle = this.getProductHandleForExternalMatching(productData);

        if (!hostHandlesCsv || !productHandle) return false;

        const hostHandles = hostHandlesCsv
            .split(',')
            .map((handle) => String(handle).trim().toLowerCase())
            .filter((handle) => !!handle);

        return hostHandles.length ? hostHandles.includes(productHandle) : false;
    }

    appendExternalVariantOption(variantSelector, productData, pickerType) {
        const externalConfigs = this.getExternalVariantConfigs(variantSelector);
        if (!externalConfigs.length) return;

        if (pickerType === 'dropdown') {
            const firstSelect = variantSelector.querySelector('.variant-block__dropdown select');
            if (!firstSelect) return;

            const optionValueId = firstSelect.options?.[0]?.dataset?.optionValueId || '';
            if (!optionValueId) return;

            for (const externalConfig of externalConfigs) {
                if (!this.isExternalVariantAllowedForProduct(externalConfig, productData)) continue;
                if (firstSelect.querySelector(`option[data-external-variant-id="${externalConfig.externalVariantId}"]`)) continue;

                const optionElement = document.createElement('option');
                optionElement.value = externalConfig.externalVariantLabel;
                optionElement.textContent = externalConfig.externalVariantLabel;
                optionElement.setAttribute('data-option-value-id', optionValueId);
                optionElement.setAttribute('data-external-variant-id', String(externalConfig.externalVariantId));
                firstSelect.appendChild(optionElement);
            }
            return;
        }

        if (pickerType === 'button') {
            const firstFieldset = variantSelector.querySelector('.variant-select__button .product-form__input');
            if (!firstFieldset) return;

            const firstRadio = firstFieldset.querySelector('input[type="radio"]');
            if (!firstRadio) return;

            const optionValueId = firstRadio.dataset.optionValueId || '';
            if (!optionValueId) return;

            for (const externalConfig of externalConfigs) {
                if (!this.isExternalVariantAllowedForProduct(externalConfig, productData)) continue;
                if (firstFieldset.querySelector(`input[data-external-variant-id="${externalConfig.externalVariantId}"]`)) continue;

                const radioId = `${firstRadio.name}-external-${externalConfig.externalVariantId}`;

                const input = document.createElement('input');
                input.type = 'radio';
                input.id = radioId;
                input.name = firstRadio.name;
                input.setAttribute('form', firstRadio.getAttribute('form') || '');
                input.value = externalConfig.externalVariantLabel;
                input.className = 'pill-radio';
                input.setAttribute('data-option-value-id', optionValueId);
                input.setAttribute('data-external-variant-id', String(externalConfig.externalVariantId));

                const label = document.createElement('label');
                label.className = 'pill-label';
                label.setAttribute('for', radioId);
                label.textContent = externalConfig.externalVariantLabel;

                firstFieldset.appendChild(input);
                firstFieldset.appendChild(label);
            }
        }
    }

    removeDisallowedExternalVariantOptions(productData) {
        const variantSelector = this.getActiveVariantSelector();
        if (!variantSelector) return;

        const externalConfigs = this.getExternalVariantConfigs(variantSelector);
        const allowedExternalIds = new Set();
        for (const externalConfig of externalConfigs) {
            if (this.isExternalVariantAllowedForProduct(externalConfig, productData)) {
                allowedExternalIds.add(String(externalConfig.externalVariantId));
            }
        }

        const externalOptions = variantSelector.querySelectorAll('option[data-external-variant-id]');
        for (const option of externalOptions) {
            const externalVariantId = option.getAttribute('data-external-variant-id') || '';
            if (!allowedExternalIds.has(externalVariantId)) {
                option.remove();
            }
        }

        const externalInputs = variantSelector.querySelectorAll('input[data-external-variant-id]');
        for (const input of externalInputs) {
            const externalVariantId = input.getAttribute('data-external-variant-id') || '';
            if (allowedExternalIds.has(externalVariantId)) continue;

            const label = variantSelector.querySelector(`label[for="${input.id}"]`);
            if (label) label.remove();
            input.remove();
        }
    }

    startExternalVariantVisibilityGuard(productData) {
        this.removeDisallowedExternalVariantOptions(productData);

        if (this.externalVariantGuardTimer) {
            clearInterval(this.externalVariantGuardTimer);
            this.externalVariantGuardTimer = null;
        }

        const guardStartedAt = Date.now();
        this.externalVariantGuardTimer = setInterval(() => {
            this.removeDisallowedExternalVariantOptions(productData);

            if (Date.now() - guardStartedAt >= 3000) {
                clearInterval(this.externalVariantGuardTimer);
                this.externalVariantGuardTimer = null;
            }
        }, 250);
    }

    isVariantHiddenFromPdp(variant) {
        return variant?.hide_from_pdp === true;
    }

    getVisibleVariants(productData) {
        const variants = Array.isArray(productData?.variants) ? productData.variants : [];
        return variants.filter((variant) => !this.isVariantHiddenFromPdp(variant));
    }

    getFirstVisibleVariant(productData) {
        const visibleVariants = this.getVisibleVariants(productData);
        return visibleVariants[0] || null;
    }

    getVariantOptionValueByPosition(variant, position) {
        if (position === 1) return variant?.option1;
        if (position === 2) return variant?.option2;
        if (position === 3) return variant?.option3;
        return undefined;
    }

    getMatchingVisibleVariants(productData, optionPosition, optionValue) {
        const visibleVariants = this.getVisibleVariants(productData);
        return visibleVariants.filter((variant) => {
            const variantOptionValue = this.getVariantOptionValueByPosition(variant, optionPosition);
            return variantOptionValue === optionValue;
        });
    }

    createDropdownVariantPicker(container, productData, sectionId) {
        const dropdownContainer = document.createElement('div');
        dropdownContainer.className = 'variant-block__dropdown';

        productData.options.forEach((option, optionIndex) => {
            // Skip Color options
            if (option.name === 'Color') return;

            const label = document.createElement('label');
            label.className = 'option__label';
            label.setAttribute('for', `Option-${sectionId}-${optionIndex}`);
            label.textContent = this.resolveVariantOptionLabel(container, option.name);

            const fieldset = document.createElement('fieldset');
            fieldset.className = 'product-form__input';

            const select = document.createElement('select');
            select.name = `options[${option.name}]`;
            select.id = `Option-${sectionId}-${optionIndex}`;
            select.setAttribute('form', `product-form-${sectionId}`);

            let renderedOptionIndex = 0;
            option.values.forEach((value) => {
                const matchingVisibleVariants = this.getMatchingVisibleVariants(productData, option.position, value.value);
                if (!matchingVisibleVariants.length) return;

                const firstMatchingVariant = matchingVisibleVariants[0];
                const hasAvailableVariant = matchingVisibleVariants.some((variant) => !!variant.available);
                const lowStockVariant = matchingVisibleVariants.find((variant) => !!variant.available) || firstMatchingVariant;
                const preferredVariant = matchingVisibleVariants.find((variant) => !!variant.available) || firstMatchingVariant;

                const optionElement = document.createElement('option');
                optionElement.id = `${sectionId}-${option.position}-${renderedOptionIndex}`;
                optionElement.value = value.value;
                const displayValue = this.getDisplayOptionValue(option.name, value.value);
                optionElement.textContent = displayValue;
                optionElement.setAttribute('data-option-value-id', value.id);
                if (preferredVariant?.id) {
                    optionElement.setAttribute('data-variant-id', String(preferredVariant.id));
                }
                
                // Add product URL if available
                if (value.product_url) {
                    optionElement.setAttribute('data-product-url', value.product_url);
                }
                
                // Add low stock attribute if applicable
                if (lowStockVariant && lowStockVariant.inventory_quantity <= 10 && lowStockVariant.inventory_quantity > 0) {
                    optionElement.setAttribute('data-low-stock', 'true');
                }
                
                // Add unavailable styling if variant is not available
                if (!hasAvailableVariant) {
                    optionElement.style.color = 'red';
                    optionElement.style.textDecoration = 'line-through';
                    optionElement.textContent = `${displayValue} Unavailable`;
                }

                if (renderedOptionIndex === 0) {
                    optionElement.selected = true;
                }

                select.appendChild(optionElement);
                renderedOptionIndex += 1;
            });

            if (!select.options.length) return;

            fieldset.appendChild(select);
            dropdownContainer.appendChild(label);
            dropdownContainer.appendChild(fieldset);
        });

        container.appendChild(dropdownContainer);
    }

    createButtonVariantPicker(container, productData, sectionId) {
        const isInQuickAddModal = this.closest('quick-add-modal');
        
        if (isInQuickAddModal) {
            const sizeValues = new Set();
            
            this.getVisibleVariants(productData).forEach(variant => {
                if (variant.option1 && variant.option1 !== 'Default Title') {
                    sizeValues.add(variant.option1);
                }
            });
            
            const buttonContainer = document.createElement('div');
            buttonContainer.className = 'variant-select__button';
            
            const fieldset = document.createElement('fieldset');
            fieldset.className = 'product-form__input';
            
            const legend = document.createElement('legend');
            legend.className = 'option__label';
            legend.textContent = this.resolveVariantOptionLabel(container, 'Select a Size');
            fieldset.appendChild(legend);
            
            const valuesArray = Array.from(sizeValues);
            
            valuesArray.forEach((value, valueIndex) => {
                const matchingVisibleVariants = this.getMatchingVisibleVariants(productData, 1, value);
                if (!matchingVisibleVariants.length) return;

                const matchingVariant = matchingVisibleVariants[0];
                const isAvailable = matchingVisibleVariants.some((variant) => !!variant.available);
                
                const input = document.createElement('input');
                input.type = 'radio';
                input.id = `${sectionId}-1-${valueIndex}`;
                input.name = 'Size-1';
                input.setAttribute('form', `product-form-${sectionId}`);
                input.value = value;
                input.className = isAvailable ? 'pill-radio' : 'pill-radio disabled';
                input.setAttribute('data-product-url', '');
                if (matchingVariant?.id) {
                    input.setAttribute('data-variant-id', String(matchingVariant.id));
                }
                
                if (matchingVariant && matchingVariant.id) {
                    input.setAttribute('data-option-value-id', matchingVariant.id);
                } else {
                    // Find the option value ID from the product data
                    const optionValue = productData.options.find(opt => opt.name === 'Size')?.values.find(val => val.value === value);
                    if (optionValue && optionValue.id) {
                        input.setAttribute('data-option-value-id', optionValue.id);
                    }
                }
                
                if (!isAvailable) {
                    input.disabled = true;
                } 
                
                const label = document.createElement('label');
                label.className = isAvailable ? 'pill-label' : 'pill-label pill-disabled';
                label.setAttribute('for', input.id);
                label.textContent = this.getDisplayOptionValue('Size', value);
                
                fieldset.appendChild(input);
                fieldset.appendChild(label);
            });
            
            buttonContainer.appendChild(fieldset);
            container.appendChild(buttonContainer);
            
        } else {
            const buttonContainer = document.createElement('div');
            buttonContainer.className = 'variant-select__button';

            productData.options.forEach((option, optionIndex) => {
                // Skip Color options
                if (option.name === 'Color') return;

                const fieldset = document.createElement('fieldset');
                fieldset.className = 'product-form__input';

                const legend = document.createElement('legend');
                legend.className = 'option__label';
                legend.textContent = this.resolveVariantOptionLabel(container, option.name);
                fieldset.appendChild(legend);

                let renderedOptionIndex = 0;
                option.values.forEach((value) => {
                    const matchingVisibleVariants = this.getMatchingVisibleVariants(productData, option.position, value.value);
                    if (!matchingVisibleVariants.length) return;

                    const preferredVariant = matchingVisibleVariants.find((variant) => !!variant.available) || matchingVisibleVariants[0];
                    const hasAvailableVariant = matchingVisibleVariants.some((variant) => !!variant.available);

                    const input = document.createElement('input');
                    input.type = 'radio';
                    input.id = `${sectionId}-${option.position}-${renderedOptionIndex}`;
                    input.name = `${option.name}-${option.position}`;
                    input.setAttribute('form', `product-form-${sectionId}`);
                    input.value = value.value;
                    input.className = 'pill-radio';
                    input.setAttribute('data-option-value-id', value.id);
                    if (preferredVariant?.id) {
                        input.setAttribute('data-variant-id', String(preferredVariant.id));
                    }
                    
                    // Add product URL if available
                    if (value.product_url) {
                        input.setAttribute('data-product-url', value.product_url);
                    }

                    if (renderedOptionIndex === 0) {
                        input.checked = true;
                    }

                    if (!hasAvailableVariant) {
                        input.disabled = true;
                        input.className = 'pill-radio disabled';
                    }

                    const label = document.createElement('label');
                    label.className = hasAvailableVariant ? 'pill-label' : 'pill-label pill-disabled';
                    label.setAttribute('for', input.id);
                    label.textContent = this.getDisplayOptionValue(option.name, value.value);

                    fieldset.appendChild(input);
                    fieldset.appendChild(label);
                    renderedOptionIndex += 1;
                });

                const fieldsetInputs = fieldset.querySelectorAll('input[type="radio"]');
                if (!fieldsetInputs.length) return;

                buttonContainer.appendChild(fieldset);
            });

            container.appendChild(buttonContainer);
        }
    }

    updatePageInfo(productData) {
        const isInQuickAddModal = this.closest('quick-add-modal');
        
        if (!isInQuickAddModal) {
            if (productData.url && window.history && window.history.replaceState) {
                
                const firstVariant = this.getFirstVisibleVariant(productData);
                const urlWithVariant = firstVariant ? 
                    `${productData.url}?variant=${firstVariant.id}` : 
                    productData.url;
                
                
                window.history.replaceState({}, '', urlWithVariant);
                
                
                const productInfo = document.querySelector('product-info');
                if (productInfo) {
                    productInfo.setAttribute('data-url', productData.url);
                }
            }

            if (productData.title) {
                document.title = productData.title;
            }
        }
    }

    formatPrice(priceInCents) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(priceInCents / 100);
    }


    recreateZoomIcon() {
        if (!this.mediaGallery) return;

          
        const originalZoomIcon = this.mediaGallery.querySelector('.product__media-icon');
        if (!originalZoomIcon) return;

          
        const existingZoomIcon = this.mediaGallery.querySelector('.product__media-icon');
        if (existingZoomIcon) {
            existingZoomIcon.remove();
        }

          
        const newZoomIcon = originalZoomIcon.cloneNode(true);
        const swiperContainer = this.mediaGallery.querySelector('.swiper');
        if (swiperContainer) {
            swiperContainer.appendChild(newZoomIcon);
        }

        // Reinitialize lightbox functionality for the new zoom elements
        setTimeout(() => {
            this.reinitializeLightbox();
        }, 50);
    }

    updateModalContent(productData) {
        const sectionId = this.getSectionId();
        const modal = document.querySelector(`#ProductModal-${sectionId}`);
        if (!modal || !productData.media) return;

        const modalContent = modal.querySelector('.product-media-modal__content');
        if (!modalContent) return;

        // Clear existing modal content
        modalContent.innerHTML = '';

        // Add each media item directly to the modal with proper modal formatting
        productData.media.forEach((media) => {
            this.createModalMediaElement(media, modalContent);
        });
    }

    createModalMediaElement(media, container) {
        if (media.media_type === 'image') {
            const img = document.createElement('img');
            
            // Clean the URL and add width parameter for modal (larger size)
            const baseSrc = media.src.split('?')[0];
            const urlParams = new URLSearchParams(media.src.split('?')[1] || '');
            urlParams.set('width', '1200');
            img.src = `${baseSrc}?${urlParams.toString()}`;
            
            img.alt = media.alt || '';
            img.setAttribute('data-media-id', media.id);
            img.loading = 'eager';
            img.className = 'image-magnify-hover';
            img.setAttribute('fetchpriority', 'high');
            
            // Add height if available
            if (media.height) {
                img.height = media.height;
            }
            
            // Generate srcset for responsive images in modal
            const srcsetSizes = [352, 832, 1200, media.width || 1223];
            const srcset = srcsetSizes.map(width => {
                const params = new URLSearchParams(media.src.split('?')[1] || '');
                params.set('width', width.toString());
                return `${baseSrc}?${params.toString()} ${width}w`;
            }).join(', ');
            
            img.setAttribute('srcset', srcset);
            
            container.appendChild(img);
        } else if (media.media_type === 'video') {
            const video = document.createElement('video');
            video.setAttribute('playsinline', 'true');
            video.setAttribute('controls', 'controls');
            video.setAttribute('autoplay', 'autoplay');
            video.setAttribute('loop', 'loop');
            video.setAttribute('preload', 'none');
            video.setAttribute('muted', 'muted');
            video.setAttribute('data-media-id', media.id);
            
            if (media.alt) {
                video.setAttribute('aria-label', media.alt);
            }
            
            if (media.preview_image?.src) {
                // Optimize poster image
                const posterBaseSrc = media.preview_image.src.split('?')[0];
                const posterParams = new URLSearchParams(media.preview_image.src.split('?')[1] || '');
                posterParams.set('width', '1200');
                video.setAttribute('poster', `${posterBaseSrc}?${posterParams.toString()}`);
            }
            
            // Add source element
            if (media.sources && media.sources.length > 0) {
                const source = document.createElement('source');
                source.src = media.sources[0].url;
                source.type = media.sources[0].mime_type || 'video/mp4';
                video.appendChild(source);
            }
            
            // Add fallback image
            if (media.preview_image?.src) {
                const fallbackImg = document.createElement('img');
                const fallbackBaseSrc = media.preview_image.src.split('?')[0];
                const fallbackParams = new URLSearchParams(media.preview_image.src.split('?')[1] || '');
                fallbackParams.set('width', '1200');
                fallbackImg.src = `${fallbackBaseSrc}?${fallbackParams.toString()}`;
                fallbackImg.alt = media.alt || '';
                fallbackImg.setAttribute('fetchpriority', 'high');
                video.appendChild(fallbackImg);
            }
            
            container.appendChild(video);
        } else {
            // Handle other media types
            const img = document.createElement('img');
            const previewSrc = media.preview_image?.src || media.src;
            
            // Clean the URL and add width parameter
            const baseSrc = previewSrc.split('?')[0];
            const urlParams = new URLSearchParams(previewSrc.split('?')[1] || '');
            urlParams.set('width', '1200');
            img.src = `${baseSrc}?${urlParams.toString()}`;
            
            img.alt = media.alt || '';
            img.setAttribute('data-media-id', media.id);
            img.loading = 'eager';
            img.className = 'image-magnify-hover';
            img.setAttribute('fetchpriority', 'high');
            
            // Add height if available
            if (media.preview_image?.height || media.height) {
                img.height = media.preview_image?.height || media.height;
            }
            
            container.appendChild(img);
        }
    }

    reinitializeLightbox() {
        const mediaSlides = document.querySelectorAll('media-gallery .swiper-slide .light-box-zoom-trigger');
        if (!mediaSlides.length) return;
        
        mediaSlides.forEach((slide) => {
            const newSlide = slide.cloneNode(true);
            slide.parentNode.replaceChild(newSlide, slide);
            
            newSlide.addEventListener('click', () => {
                const modal = document.querySelector(newSlide.getAttribute('data-modal'));
                if (modal) modal.showModal(newSlide);
            });
        });
    }

    reinitializeMagnify() {
        const magnifyElement = document.querySelector('product-media-magnify');
        if (magnifyElement && typeof magnifyElement.reinitialize === 'function') {
            magnifyElement.reinitialize();
        }
    }

    initThumbnails() {
        const thumbnails = this.mediaGallery?.querySelectorAll('.thumbnail-item');
        if (!thumbnails) return;

        thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
                if (this.swiper) {
                    this.swiper.slideTo(index);
                }
                this.updateThumbnailActive(index);
            });
        });

        if (thumbnails.length > 0) {
            this.updateThumbnailActive(0);
        }
    }

    updateThumbnailActive(activeIndex = 0) {
        const thumbnails = this.mediaGallery?.querySelectorAll('.thumbnail-item');
        if (!thumbnails) return;

        thumbnails.forEach((thumbnail, index) => {
            thumbnail.classList.toggle('active', index === activeIndex);
        });
    }

    clickFirstVariant(variantSelector) {
        const pickerType = variantSelector.getAttribute('data-picker-type');

        if (pickerType === 'dropdown') {
            const firstSelect = variantSelector.querySelector('select');
            if (firstSelect && firstSelect.options.length > 0) {
                
                firstSelect.selectedIndex = 0;
                firstSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
        } else if (pickerType === 'button') {
            const radioInputs = variantSelector.querySelectorAll('input[type="radio"]');
            let firstAvailableRadio = null;
            
            for (const radio of radioInputs) {
                if (!radio.classList.contains('disabled') && !radio.disabled) {
                    firstAvailableRadio = radio;
                    break;
                }
            }
            
            if (firstAvailableRadio) {
                firstAvailableRadio.checked = true;
                firstAvailableRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    hideVariantSelectorTemporarily() {
        const variantSelector = document.querySelector('variant-selector');
        if (!variantSelector) return;

        variantSelector.style.opacity = '0';

        setTimeout(() => {
            variantSelector.style.opacity = '';
        }, 1000);
    }

    updateNotifyMePopup(productData) {
        const existingPopup = document.querySelector('notify-me-popup');
        if (!existingPopup) return;

        const productUrl = `/products/${productData.handle}`;
        const sectionId = 'component-notify-me-popup';
        
        existingPopup.style.opacity = '0.5';
        
        fetch(`${productUrl}?section_id=${sectionId}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then(responseText => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(responseText, 'text/html');
                const newPopup = doc.querySelector('notify-me-popup');
                
                if (newPopup) {
                    const currentDisplay = existingPopup.style.display;
                    
                    existingPopup.parentNode.replaceChild(newPopup, existingPopup);
                    
                    newPopup.style.display = currentDisplay;
                    newPopup.style.opacity = '';
                } else {
                    existingPopup.style.opacity = '';
                }
            })
            .catch(() => {
                existingPopup.style.opacity = '';
            });
    }

    getTiloPromoElement() {
        if (window.Shop?.productInfoEl) {
            const scopedPromo = window.Shop.productInfoEl.querySelector('tilo-free-sock-promo');
            if (scopedPromo) return scopedPromo;
        }

        return document.querySelector('tilo-free-sock-promo');
    }

    getProductTags(productData) {
        const rawTags = productData?.tags;
        if (Array.isArray(rawTags)) {
            return rawTags.map((tag) => String(tag).trim()).filter((tag) => !!tag);
        }

        if (typeof rawTags === 'string') {
            return rawTags
                .split(',')
                .map((tag) => String(tag).trim())
                .filter((tag) => !!tag);
        }

        return [];
    }

    isTiloPromoEligible(productData, promoTag) {
        const normalizedTag = String(promoTag || '').trim().toLowerCase();
        if (!normalizedTag) return true;

        const productTags = this.getProductTags(productData);
        return productTags.some((tag) => tag.toLowerCase() === normalizedTag);
    }

    updateTiloFreeSockPromo(productData, clickedVariant) {
        const promoElement = this.getTiloPromoElement();
        if (!promoElement) return;

        const clickedEligibility = String(clickedVariant?.dataset?.tiloFreeSockEligible || '').trim().toLowerCase();
        const promoTag = String(promoElement.dataset.promoTag || '').trim();
        const shouldShowPromo = clickedEligibility
            ? clickedEligibility === 'true'
            : this.isTiloPromoEligible(productData, promoTag);

        promoElement.dataset.promoActive = shouldShowPromo ? 'true' : 'false';
        promoElement.hidden = !shouldShowPromo;
    }

    getTickerCalloutElement() {
        if (window.Shop?.productInfoEl) {
            const scopedTicker = window.Shop.productInfoEl.querySelector('.preorder-banner-tilo[data-ticker-product-handles]');
            if (scopedTicker) return scopedTicker;
        }

        return document.querySelector('.preorder-banner-tilo[data-ticker-product-handles]');
    }

    getProductHandle(productData) {
        const directHandle = String(productData?.handle || '').trim().toLowerCase();
        if (directHandle) return directHandle;

        const productUrl = String(productData?.url || '').trim();
        if (!productUrl) return '';

        try {
            const url = new URL(productUrl, window.location.origin);
            const pathSegments = url.pathname.split('/').filter(Boolean);
            const productsIndex = pathSegments.indexOf('products');
            if (productsIndex === -1) return '';
            return String(pathSegments[productsIndex + 1] || '').trim().toLowerCase();
        } catch (error) {
            const match = productUrl.match(/\/products\/([^/?#]+)/i);
            return match?.[1] ? String(match[1]).trim().toLowerCase() : '';
        }
    }

    isTickerCalloutEligible(productData, tickerProductHandlesCsv) {
        const normalizedHandles = String(tickerProductHandlesCsv || '')
            .split(',')
            .map((handle) => String(handle).trim().toLowerCase())
            .filter((handle) => !!handle);

        if (!normalizedHandles.length) return true;

        const productHandle = this.getProductHandle(productData);
        if (!productHandle) return false;

        return normalizedHandles.includes(productHandle);
    }

    updateTickerCallout(productData) {
        const tickerCalloutElement = this.getTickerCalloutElement();
        if (!tickerCalloutElement) return;

        const tickerProductHandlesCsv = tickerCalloutElement.dataset.tickerProductHandles || '';
        const shouldShowTicker = this.isTickerCalloutEligible(productData, tickerProductHandlesCsv);

        tickerCalloutElement.dataset.tickerActive = shouldShowTicker ? 'true' : 'false';
        tickerCalloutElement.hidden = !shouldShowTicker;
    }

    addVariantSelectorEventListeners(container) {
        // Use event delegation to handle dynamically created elements
        container.addEventListener('change', (e) => {
            if (e.target.tagName === 'SELECT' || (e.target.tagName === 'INPUT' && e.target.type === 'radio')) {
                // Get the selected variant and update button directly
                this.updateButtonForSelectedVariant(e.target);
            }
        });
    }

    updateButtonForSelectedVariant(selectedElement) {
        // Get the product data from the active color variant
        const activeColorVariant = document.querySelector('color-variants .color-variant-single.active');
        if (!activeColorVariant) return;

        const productDataString = activeColorVariant.dataset.productJson;
        if (!productDataString) return;

        try {
            const productData = JSON.parse(productDataString);
            
            // Get all currently selected option values
            const selectedOptions = this.getSelectedOptionValues();
            
            // Find the variant that matches all selected options
            let selectedVariant = null;
            
            if (selectedOptions.length > 0) {
                selectedVariant = this.getVisibleVariants(productData).find((variant) => {
                    if (!variant || !variant.options) return false;
                    return variant.options.every((option, index) => {
                        return option === selectedOptions[index];
                    });
                });
            } else {
                selectedVariant = this.getFirstVisibleVariant(productData);
            }

            if (selectedVariant) {
                // Update the button based on variant availability
                this.updateAddToCartButton(selectedVariant);
            }
        } catch (error) {
            console.error('Error updating button for selected variant:', error);
        }
    }

    getSelectedOptionValues() {
        const variantSelector = document.querySelector('variant-selector');
        if (!variantSelector) return [];
        if (!variantSelector) {
            return [];
        }

        const selectedValues = [];
        
        // Get values from select elements
        const selectElements = variantSelector.querySelectorAll('select');
        selectElements.forEach(select => {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption) {
                selectedValues.push(selectedOption.value);
            }
        });
        
        // Get values from radio buttons
        const radioInputs = variantSelector.querySelectorAll('input[type="radio"]:checked');
        radioInputs.forEach(input => {
            selectedValues.push(input.value);
        });
        
        return selectedValues;
    }

    updateAddToCartButton(variant) {
        const productInfo =
            window.Shop?.productInfoEl ||
            this.closest('product-info') ||
            document.querySelector('product-info');
        if (!productInfo) return;

        const addToCartForm = productInfo.querySelector('ajax-cart-product-form');
        const notifyMeTrigger = productInfo.querySelector('.notify-me-popup-trigger');
        
        if (!addToCartForm || !notifyMeTrigger) return;
        
        const checkedPillRadio = productInfo.querySelector('input.pill-radio:checked');
        const isPillMarkedUnavailable = checkedPillRadio
            ? checkedPillRadio.classList.contains('disabled') || checkedPillRadio.hasAttribute('disabled')
            : false;
        const addToCartButton = productInfo.querySelector('button[name="add"]');
        const isVariantAvailableFromData = typeof variant?.available === 'boolean'
            ? variant.available
            : !addToCartButton?.disabled;
        const isVariantAvailable = !isPillMarkedUnavailable && isVariantAvailableFromData;

        addToCartForm.style.display = 'none';
        notifyMeTrigger.style.display = 'none';
        
        if (isVariantAvailable) {
            addToCartForm.style.display = 'block';
        } else {
            notifyMeTrigger.style.display = 'block';
        }
        
        // Update variant input value
        const variantInput = addToCartForm.querySelector('input[name="id"]');
        if (variantInput && variant) {
            variantInput.value = variant.id;
        }
    }
}

try {
    customElements.define(COLOR_VARIANTS_TAG, ColorVariants);
} catch (error) {
    if (!String(error?.message || '').includes('has already been used')) {
        throw error;
    }
}
})();